import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Select, Checkbox } from 'antd'
import {
  getCtInspctionType,
  getApsCard97MelSelection,
  getStationCodeList,
} from 'api/pgads'
import { ErrorContext } from 'context'
import { connect } from 'react-redux'
import { getApiTargetInfo } from 'core'
const { Option } = Select

const ApsExtension = props => {
  const {
    data,
    allData,
    handleExtSave,
    disableComp = false,
    targetInfo,
    // units,
  } = props

  const { setError } = useContext(ErrorContext)

  const { string5, string8, string7 } = data
  const { unit, causeCode } = allData

  const [ctList, setCtList] = useState([])
  // eslint-disable-next-line no-unused-vars
  const [stationCodeList, setStationCodeList] = useState([])

  const [melSectionList, setMelSelectionList] = useState([])

  useEffect(
    _ => {
      getCtInspctionType(targetInfo).fork(setError, data => {
        setCtList(data)
      })
      getStationCodeList(targetInfo).fork(setError, data => {
        setStationCodeList(data)
      })
    },
    [setError, targetInfo]
  )

  useEffect(
    _ => {
      getApsCard97MelSelection(targetInfo)(unit).fork(setError, data => {
        setMelSelectionList(data)
      })
    },
    [setError, targetInfo, unit]
  )

  const melCodeSelection = useMemo(
    _ => {
      // const curUnitStation = units.find(u => unit === u.utility + u.unit)
      //   .station
      // const stationList = stationCodeList
      //   .filter(f => f.stationCode === curUnitStation)
      //   .map(s => s.stationCode)
      // const componentList = melSectionList.filter(f =>
      //   stationList.includes(f.stationCode)
      // )
      return melSectionList.filter(f => f.causeCode === causeCode)
    },
    [causeCode, melSectionList]
  )

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '150px 1fr',
        gridGap: '30px',
      }}
    >
      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>MEL Code :</div>
      <Select
        value={string7}
        onChange={value => handleExtSave('string7', value)}
        key="string7"
        disabled={disableComp}
      >
        <Option key="-1" value="" style={{ height: '20px' }} />
        {melCodeSelection.map(({ display }) => (
          <Option
            key={display.substr(0, display.indexOf(':'))}
            value={display.substr(0, display.indexOf(':'))}
          >
            {display}
          </Option>
        ))}
      </Select>
      <div />
      <Checkbox
        checked={string8 === 'Y'}
        onChange={e => handleExtSave('string8', e.target.checked ? 'Y' : 'N')}
        key="string8"
      >
        Exclude from CA
      </Checkbox>

      <div style={{ justifySelf: 'end', alignSelf: 'center' }}>
        Inseption Type :
      </div>
      <Select
        value={string5}
        onChange={value => handleExtSave('string5', value)}
        key="string5"
        disabled={disableComp}
      >
        <Option key="-1" value="" style={{ height: '20px' }} />
        {ctList.map(({ inspectionId, inspectionType }) => (
          <Option key={inspectionId} value={inspectionId}>
            {inspectionId}-{inspectionType}
          </Option>
        ))}
      </Select>
    </div>
  )
}

export default connect(state => ({ targetInfo: getApiTargetInfo(state) }))(
  ApsExtension
)
